
var ErrorHelper = {};

ErrorHelper.csErrorString = function(status, response, contextStr, errorInfo) {
      // explaining known status
      var errorStr = "<span style='font-weight:800;'>Error "+ status +": ";
      if(status == 0) errorStr += "The server could not be reached.";
      if(status == 401) errorStr += "User must be logged in to see this content.";
      if(status == 403) errorStr += "The current user is not authorized to see this content.";
      if(status == 404) errorStr += "The requested content does not exist.";
      if(status == 408) errorStr += "The connection has timed out.";
      if(status == 409) errorStr += "There is a conflict with this request.";
      if(status == 500) errorStr += "The server has encountered an error (more details below).";
      errorStr += "</span><br>";

      // explaining forum
      errorStr += "  If this error is unexpected, please report it to <br>";
      errorStr += ErrorHelper.getSupportLink();
      errorStr += " and include the information below. <br><br>";

      // custom information (at the top because it's usually very relevant)
      if(errorInfo){
          for(var key in errorInfo){
              if(errorInfo.hasOwnProperty(key)){
                  errorStr += "<span "+this.bold()+">"+key+"</span>: " + errorInfo[key]+"<br>";
              }
          }
      }

      // basic information
      errorStr += "<span "+this.bold()+">Code</span>: "+ status +"<br>";
      errorStr += "<span "+this.bold()+">Details</span>: ";
      if(contextStr) errorStr += "This error occurred while " + contextStr+ "<br>";
      else errorStr += "n/a";

      var date = new Date(); 
      var time = date.getMonth() + "/"+ (date.getDate()+1)  + "/" + date.getFullYear() + " @ "  + date.getHours() + ":"  + date.getMinutes() + ":" + date.getSeconds();
      errorStr += "<span "+this.bold()+">Time</span>: "+ time +"<br>";

      // server message
      errorStr += "<span "+this.bold()+">Server Message</span>: <br>"
      if(response) errorStr += "<div "+this.scroll()+">"+response + "</div><br>";
      else errorStr += "n/a<br>"

      return errorStr;
}

ErrorHelper.getForumLink = function(){
      return " <a href='https://forums.autodesk.com/t5/eagle-forum/bd-p/3500' target='_blank'>EAGLE forum</a>";
}

ErrorHelper.getSupportLink = function(){
      return " <a href='https://knowledge.autodesk.com/contact-support/using-my-product' target='_blank'>Autodesk Support</a>";
}

// ~not supposed to do this
ErrorHelper.bold = function(){
  return " style='font-weight:800;text-decoration:underline;'";
}

ErrorHelper.scroll = function(){
  return " style='max-height:120px;border:1px solid #ccc;overflow:auto; color:black;margin-top:6px;margin-bottom:6px;padding:7px;'";
}

ErrorHelper.exceptionErrorString = function(message, stack, location, context, willBeConcatinated, isExpectedError) {
      var errorStr = "";
      if(!isExpectedError){
          if(!willBeConcatinated){

              errorStr += "The Editor has encountered an issue.  Please report the following log to ";
              errorStr += ErrorHelper.getSupportLink();
              errorStr += " so we can help identify and resolve the issue.<br><br>";
          } else {
              errorStr += "<br><b>A related exception also occurred:</b><br>"
          }
      }

      if(!isExpectedError){
          errorStr += "<span "+this.bold()+">Error:</span> " + message + "<br>";
          errorStr += "<span "+this.bold()+">Caught Inside:</span> " + location +"<br>";
          if(context) errorStr += "<span "+this.bold()+">Details:</span> " + context + "<br>";
          errorStr += "<span "+this.bold()+">Stack Trace:</span>"; 
          errorStr += "<br><div "+this.scroll()+">" 
          errorStr += stack + "<br>";
          errorStr += "</div>"
          
      } else {
          errorStr += message + "<br><br>";
          if(context) errorStr += context + "<br>";
      }
    
      return errorStr;
}

module.exports = ErrorHelper;


